<template>
  <v-container fluid>
    <v-card
      flat
      width="640px"
      class="mx-auto"
    >
      <span class="text-h6">{{ id ? 'Изменение машины в очереди' : 'Добавление машины в очередь' }}</span>

      <v-divider />

      <v-row
        align="center"
        justify="center"
        no-gutters
      >
        <v-col cols="6 pl-0 pr-4 pt-3">
          <CargoTypeSelector
            v-model="cargoTypeID"
            :error-messages="cargoTypeIDErrors"
            @input="$v.cargoTypeID.$touch()"
            @blur="$v.cargoTypeID.$touch()"
          />
        </v-col>

        <v-col cols="6 pl-4 pr-0 pt-3">
          <CarOperationTypeSelector
            v-model="carOperationTypeID"
            :error-messages="carOperationTypeIDErrors"
            :can-combo="!id"
            :can-any="false"
            @input="$v.carOperationTypeID.$touch()"
            @blur="$v.carOperationTypeID.$touch()"
          />
        </v-col>
      </v-row>

      <v-row
        align="center"
        justify="center"
        no-gutters
      >
        <v-col cols="3 pl-0 pr-4 pt-3">
          <v-select
            v-model="carCountryID"
            :menu-props="{maxHeight: 404}"
            :items="$store.getters['directories/carCountries']"
            :loading="$store.getters['directories/loading']"
            item-text="name"
            item-value="id"
            label="Страна машины"
            :item-color="$store.getters['settings/dark'] ? 'white' : 'black'"
            :error-messages="carCountryIDErrors"
            @input="$v.carCountryID.$touch()"
            @blur="$v.carCountryID.$touch()"
          />
        </v-col>

        <v-col cols="9 pl-4 pr-0 pt-3">
          <v-text-field
            v-model="carNumber"
            autocomplete="off"
            type="text"
            label="Номер машины"
            required
            :error-messages="carNumberErrors"
            :counter="this.$v.carNumber.$params.maxLength.max"
            @input="$v.carNumber.$touch()"
            @blur="$v.carNumber.$touch()"
          />
        </v-col>

        <v-col cols="12 px-0">
          <v-text-field
            v-model="driver"
            autocomplete="off"
            type="text"
            label="ФИО Водителя"
            required
            :error-messages="driverErrors"
            :counter="this.$v.driver.$params.maxLength.max"
            @input="$v.driver.$touch()"
            @blur="$v.driver.$touch()"
          />
        </v-col>

        <v-col cols="12 px-0">
          <v-text-field
            v-model="driverPhone"
            autocomplete="off"
            type="text"
            label="Телефон водителя в формате +7ххх..."
            required
            :error-messages="driverPhoneErrors"
            :counter="this.$v.driverPhone.$params.maxLength.max"
            @input="$v.driverPhone.$touch()"
            @blur="$v.driverPhone.$touch()"
          />
        </v-col>
      </v-row>

      <v-card-actions class="px-0 pt-8">
        <v-spacer />
        <v-btn
          class="px-6"
          outlined
          :disabled="submiting"
          @click.prevent="cancelClick"
        >
          Отмена
        </v-btn>
        <v-btn
          v-if="id"
          class="px-4"
          color="primary"
          :loading="submiting"
          @click.prevent="saveClick"
        >
          Сохранить
        </v-btn>
        <v-btn
          v-else
          class="px-4"
          color="primary"
          :loading="submiting"
          @click.prevent="addClick"
        >
          Добавить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import CargoTypeSelector from '@/components/CargoTypeSelector'
import CarOperationTypeSelector from '@/components/CarOperationTypeSelector.vue'

export default {
  components: {
    CargoTypeSelector,
    CarOperationTypeSelector
  },

  props: ['id'],

  data: () => ({
    rowVersion: null,
    cargoTypeID: null,
    carOperationTypeID: null,
    carCountryID: null,
    carNumber: '',
    driver: '',
    driverPhone: '+',
    //
    submiting: false
  }),

  computed: {
    cargoTypeIDErrors () {
      if (!this.$v.cargoTypeID.$dirty) return []
      const errors = []
      !this.$v.cargoTypeID.required && errors.push('Укажите тип груза')
      return errors
    },

    carOperationTypeIDErrors () {
      if (!this.$v.carOperationTypeID.$dirty) return []
      const errors = []
      !this.$v.carOperationTypeID.required && errors.push('Выберите операцию')
      return errors
    },

    carCountryIDErrors () {
      if (!this.$v.carCountryID.$dirty) return []
      const errors = []
      !this.$v.carCountryID.required && errors.push('Укажите регион машины')
      return errors
    },

    driverErrors () {
      if (!this.$v.driver.$dirty) return []
      const errors = []
      !this.$v.driver.maxLength && errors.push(`Не более ${this.$v.driver.$params.maxLength.max} символов, пожалуйста`)
      !this.$v.driver.minLength && errors.push(`Не менее ${this.$v.driver.$params.minLength.min} символов, пожалуйста`)
      !this.$v.driver.required && errors.push('Введите ФИО водителя')
      return errors
    },

    driverPhoneErrors () {
      if (!this.$v.driverPhone.$dirty) return []
      const errors = []
      !this.$v.driverPhone.maxLength &&
        errors.push(`Не более ${this.$v.driverPhone.$params.maxLength.max} символов, пожалуйста`)
      !this.$v.driverPhone.minLength &&
        errors.push(`Не менее ${this.$v.driverPhone.$params.minLength.min} символов, пожалуйста`)
      !this.$v.driverPhone.required && errors.push('Введите телефон водителя')
      return errors
    },

    carNumberErrors () {
      if (!this.$v.carNumber.$dirty) return []
      const errors = []
      !this.$v.carNumber.maxLength &&
        errors.push(`Не более ${this.$v.carNumber.$params.maxLength.max} символов, пожалуйста`)
      !this.$v.carNumber.minLength &&
        errors.push(`Не менее ${this.$v.carNumber.$params.minLength.min} символов, пожалуйста`)
      !this.$v.carNumber.required && errors.push('Введите номер машины')
      return errors
    }
  },

  validations () {
    return {
      cargoTypeID: {
        required
      },
      carOperationTypeID: {
        required
      },
      carCountryID: {
        required
      },
      driver: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(60)
      },
      driverPhone: {
        required,
        minLength: minLength(10),
        maxLength: maxLength(15)
      },
      carNumber: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(20)
      }
    }
  },

  created () {
    if (this.id) {
      // существующая машина в очереди => просмотр / редактирование
      this.axios(`/carQueue/get/${this.id}`).then(response => {
        this.rowVersion = response.data.rowVersion
        this.cargoTypeID = response.data.cargoTypeID
        this.carOperationTypeID = response.data.carOperationTypeID
        this.carCountryID = response.data.carCountryID
        this.carNumber = response.data.carNumber
        this.driver = response.data.driver
        this.driverPhone = response.data.driverPhone
      })
    }
  },

  methods: {
    formatDriver () {
      let result = ''
      const words = this.driver.split(' ')
      words.forEach(w => {
        let newWord = w.replace(/[^a-zA-ZА-Яа-яЁё]/gi, '').replace(/\s+/gi, ', ')
        if (newWord.length) {
          newWord = newWord[0].toUpperCase() + newWord.slice(1)
          result += (result.length ? ' ' : '') + newWord
        }
      })
      this.driver = result
    },

    formatPhone () {
      this.driverPhone = '+' + this.driverPhone.replace(/[^0-9]/gi, '').replace(/\s+/gi, ', ')
    },

    formatNumber () {
      this.carNumber = this.carNumber
        .toUpperCase()
        .replace(/[^0-9a-zA-ZА-Яа-яЁё]/gi, '')
        .replace(/\s+/gi, ', ')
    },

    cancelClick () {
      this.$router.push('/carQueue')
    },

    // добавление машины в очередь
    addClick () {
      this.formatDriver()
      this.formatPhone()
      this.formatNumber()

      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      }

      this.submiting = true
      this.axios
        .post('/carQueue/insert', {
          cargoTypeID: this.cargoTypeID,
          carOperationTypeID: this.carOperationTypeID,
          carCountryID: this.carCountryID,
          carNumber: this.carNumber,
          driver: this.driver,
          driverPhone: this.driverPhone
        })
        .then(response => {
          response.data.map(i => {
            // отправляем всем остальным id + cargoTypeID
            this.$signals.invoke('CarQueue_Insert', i.id, i.cargoTypeID)
          })
          this.$router.push('/carQueue')
        })
        .catch(err => {
          this.$notify(
            'error',
            err?.response?.data?.message ? err.response.data.message : 'Ошибка при добавлении машины в очередь'
          )
        })
        .finally(() => {
          this.submiting = false
        })
    },

    // изменение машины в очереди
    saveClick () {
      this.formatDriver()
      this.formatPhone()
      this.formatNumber()

      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      }

      this.submiting = true
      this.axios
        .put('/carQueue/update', {
          id: parseInt(this.id),
          rowVersion: this.rowVersion,
          cargoTypeID: this.cargoTypeID,
          carOperationTypeID: this.carOperationTypeID,
          carCountryID: this.carCountryID,
          carNumber: this.carNumber,
          driver: this.driver,
          driverPhone: this.driverPhone
        })
        .then(() => {
          // сигнал с id изменённой записи, чтобы остальные протянули изменения
          this.$signals.invoke('CarQueue_Update', parseInt(this.id), this.cargoTypeID)
          this.$router.push('/carQueue')
        })
        .catch(err => {
          this.$notify(
            'error',
            err?.response?.data?.message ? err.response.data.message : 'Ошибка при сохранении изменений'
          )
        })
        .finally(() => {
          this.submiting = false
        })
    }
  }
}
</script>

<style scoped>
.upper-input input {
  text-transform: uppercase;
}
</style>
